React = require 'react'
t = require('views/internal/recup-with-helpers')('enterprise_public_board_empty_state')

module.exports = class PublicBoardEmptyStateComponent extends React.Component
  render: t.renderable ->
    t.div '.public-board-empty-state-container', =>
      t.img '.public-board-empty-state-image', { src: require 'images/empty-states/public-boards-empty.svg' }
      t.h5 '.public-board-empty-state-title', =>
        t.format 'public-boards'
      t.p '.public-board-empty-state-description', =>
        t.format 'if-public-boards-exist'



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/public-board-empty-state-component.coffee